module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_perform.js
// module id = 157
// module chunks = 9